import * as ol from 'openlayers'
import BaseEnlightLineAspect from './BaseEnlightLineAspect'
import { translate } from '../translation/native_translate.js';

export default class RelationAspect extends BaseEnlightLineAspect {

  constructor(data) {
    super(data);
    this.set('type', 'RoadRelation_' + data.id);
    this.set('intensity', data.intensity);
    this.set('reliability', data.reliability);
    this.set('velocity', data.velocity);
    this.set('relationId', data.relationId);
    this.set('timestamp', data.timestamp);
    this.set('subType', data.subType);
    this.set('showToolTip', data.showToolTip);
      this.set('includeCenterPoint', data.includeCenterPoint);//data.includeCenterPoint ? data.includeCenterPoint : false);
    this.setZIndex(3);

  }

  createStyle(resolution) {
    let color = "#a366ff";
    let state = this.get('state');
    switch (state) {
      case 1:
        color = "#ff0000";
        break;
      case 2:
        color = "#ff9900";
        break;
      case -1:
      case 3:
      case 4:
        color = "#009933";
        break;
    }

    switch (this.get('subType')) {
      case 'CarRoute':
        color = "#ff99cc";
        break;
      case 'BusRoute':
        color = "#6699ff";
        break;
      case 'WalkRoute':
        color = "#FFA500"; // Orange
        break;
      case 'BikeRoute':
        color = "#008000"; // Green
        break;
      case 'PublicTransportRoute':
        color = "#0000FF"; // Blue
        break;
      default:
        break;
    }

    this.setBaseColor(color);

    let width = 1;
    if (resolution > 17) {
      width = 5; //1/(resolution * 200); //view.getZoom() - 4 + (view.getZoom() - 17);
    }

    if (width < 4) {
      width = 4;
    }


    let style = [];
    style.push(new ol.style.Style({
      stroke: new ol.style.Stroke({
        color: color,
        width: width,
        lineCap: "square"
      })
    }));

    let includeCenterPoint = this.get('includeCenterPoint');
    if (includeCenterPoint) {

      let imgSrc = this.getImagePath(
        "Destination-states/","locatie-1"
      );
      if (imgSrc == -1) {
        imgSrc = this.getImagePath(
          "Destination-states/","locatie3"
        );
        color = "white";
      }

      let image = new ol.style.Icon({
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        src: imgSrc,
        anchor: [0.5, 0.5],
        color: color
      });

      let point = this.get("position");
      let pos = ol.proj.transform([parseFloat(point[0]), parseFloat(point[1])], 'EPSG:4326', 'EPSG:3857');
      let iconStyle = new ol.style.Style({
        geometry: new ol.geom.Point(pos),
        image: image
      });


      style.push(iconStyle);
    }



    return style;
  }

  createTooltip() {
    let showTl = this.get('showToolTip');
    if (showTl == false) {
      return;
    }
    let parent = this.get('parentId');
    let owner = 'undefined';
    if (typeof parent != 'undefined') {
      owner = parent.replace('_CAT_CAR', '');
    }

    let ts = 'N/A';
    if (typeof this.get('timestamp') !== 'undefined') {
      ts = new Date(this.get('timestamp') * 1000);
    }

    let tooltipInfo = "<div id='map-popup-tooltip' >"
    tooltipInfo += "<p class='pop-up-atribute' > name: " + this.get('name') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > segment-id: " + this.get('id') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > intensiteit: " + this.get('intensity') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > betrouwbaarheid: " + this.get('reliability') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > snelheid: " + this.get('velocity') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > owner: " + owner + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > state: " + this.get('state') + "</p>";
    tooltipInfo += "<p class='pop-up-atribute' > timestamp: " + ts + "</p>";
    tooltipInfo += "</div>";
    return tooltipInfo;
  }

  rightClick(pixel, gps, rightClickBehaviour = 0) {
    var forwardBehave = true;
    switch (rightClickBehaviour) {
      case 0: //normal behaviour

        break;
      case 1: //Relation creation
        forwardBehave = false;

        break;
    }

    if (forwardBehave) {
      let boxConfig = {
        customData: this.getObject(),
        gpsData: gps,
        parentId: 'ContextMenu',
        id: 'ContextMenu', //specific id for context menu box
        component: 'ContextMenu',
        name: "Menu",
        left: (pixel[0] + 10),
        top: (pixel[1] + 10 + 49), // +49 to adjust for navigation bar
        actions: [
          { 'id': '_removeAction', 'name': 'Remove', '_function': () => { this.removeObject(); } }
        ],
      }
    }
  }

  removeObject() {
    window.Event.vue.$confirm('WARNING_MESSAGE', 'WARNING_MESSAGE_TITLE', {
      confirmButtonText: translate('YES'),
      cancelButtonText: translate('NO'),
      type: 'warning'
    }).then(() => {

      const categoryCar = window.Event.vue.$store.getters.getPreferredCategoryCar;

      var requestObject = {
        "childId": {
          "datatype": "string",
          "value": this.get('relationId'),
        },
        "cleanDatabase": {
          "datatype": "bool",
          "value": true,
        }
      };

      if (categoryCar === 'undefined') {
        window.Event.vue.$notify.error({
          title: "RELATION_OBJECT_FAILS_TO_REMOVE",
          message: "ERROR",
          duration: 0
        });
      } else {
        this.setLastAction('removeObject');
        const request = window.dssUtility.createDSSRequest(categoryCar, "cleanupChild", requestObject);
        window.socket.sendMessage(request, () => {
          window.Event.vue.$notify.success({
            title: "RELATION_OBJECT_REMOVED",
            message: "Success"
          });
        });
      }
    });
  }
}
